module.exports = __webpack_public_path__ + "img/syl_gallery5.158ee415.jpg";